module.exports = __webpack_public_path__ + "img/service.7f759c6b.png";